import { Link } from 'react-router-dom';
import * as style from '../../utils/general_style.js';
import * as links from '../../utils/general_links.js';

function Checkbox({ checked, id, onChange, required=true }) {

	return (
        <div style={{...style.ROW_SPACE_BETWEEN, fontSize: '14px'}}>
            <input id={ id } name={ id } onChange={ onChange } type="checkbox" style={{opacity: '0', position: 'absolute'}} required={ required } />
            <div><i className={(checked) ? "fa-solid fa-square-check" : "fa-regular fa-square"} style={{fontSize: '20px', color: style.COLORS.primary}}></i></div>
            <label htmlFor={ id } style={{fontSize: '14px', textAlign: 'center'}}>En soumettant ce formulaire, j'accepte que les informations saisies soient utilisées pour me recontacter, je reconnais avoir pris connaissance de votre <Link to={ links.ROUTES.politiqueProtection } style={ style.INLINE_LINK }>politique de confidentialité</Link>.</label>
        </div>
	);
};

export default Checkbox;